export enum CustomerType {
    BUSINESS='Business',
    INDIVIDUAL='Individual'
}
  